// exclude-from-index
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { StrengthIndicatorWrapper } from './PasswordStrengthIndicator.styles';
import CopyParagraph from '../../BuildingBlocks/Text/CopyParagraph/CopyParagraph';

class PasswordStrengthIndicator extends PureComponent {
  static propTypes = {
    value: PropTypes.string
  };

  static defaultProps = {
    value: ''
  };

  validatePassword = val => {
    const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,})');
    const fairRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
    if (strongRegex.test(val)) {
      return 'Strong';
    }
    if (fairRegex.test(val)) {
      return 'Fair';
    }
    if (val.length > 0) {
      return 'Weak';
    }

    return '';
  };

  render() {
    const { value } = this.props;
    return (
      <StrengthIndicatorWrapper className={this.validatePassword(value)}>
        <CopyParagraph className="label" color="tertiary" noMargins tagName="p">
          Password strength
        </CopyParagraph>
        <CopyParagraph className="strength" noMargins tagName="p">
          {this.validatePassword(value)}
        </CopyParagraph>
      </StrengthIndicatorWrapper>
    );
  }
}

export default PasswordStrengthIndicator;
